<script setup lang="ts">
import Button from './Button.vue';

defineProps<{
    href?: string;
    target?: string;
    type?: 'button' | 'submit' | 'reset';
    active?: boolean;
    pill?: boolean;
}>();
</script>

<template>
    <Button
        :href="href"
        :target="target"
        :type="type"
        :pill="pill"
        :class="{
            'border-2 border-(--az-dark-gray) font-medium outline-(--az-green-600) hover:bg-(--az-beige-200) focus:outline-3 focus:outline-offset-2': true,
            'border-(--az-coffee-600) bg-(--az-green-600) outline-(--az-green-500) hover:bg-(--az-green-700)': active,
            'text-white': active,
            'bg-white hover:border-(--az-coffee-600)': !active,
            'text-(--az-dark-gray) hover:text-neutral-900': !active,
        }"
    >
        <slot />
    </Button>
</template>
